import { render, staticRenderFns } from "./IconMicrophone.vue?vue&type=template&id=73bd8356"
import script from "./IconMicrophone.vue?vue&type=script&lang=js"
export * from "./IconMicrophone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports